// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lazy-fadein[lazy=loaded]{animation-duration:1s;animation-fill-mode:both;animation-name:lazyFadeIn}@keyframes lazyFadeIn{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
